import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isValidValue } from "utils/Utils";
import AppOutlineButton from "components/ui/AppOutlineButton";

const CancelOrder = ({ canceljeeblyOrder, cancelOrder }) => {
  const { t } = useTranslation();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);

  if (
    isValidValue(
      orderInfo?.logisticPartnerMetadata?.JEEBLY?.createDeliveryResponse?.['Order Id']
    )
  ) {
    return (
      <div>
        <div className="flex justify-center p-4">
          <AppOutlineButton variant="secondary" size="lg" onClick={canceljeeblyOrder}>
            {t("Cancel order with Jeebly")}
          </AppOutlineButton>
        </div>
      </div>
    );
  } else if (cancelOrder?.status === "CANCELLED") {
    return (
      <div className="flex justify-center p-4">
        <div>{t("Order Has been Cancelled Already")}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-center p-4">
      <div>
        {t(
          "You haven’t sent your order to Jeebly delivery yet, you can send it by clicking SEND ORDER tab"
        )}
      </div>
    </div>
  );
};

export default CancelOrder;
